import { observer } from 'mobx-react-lite';
import { ConfirmPopup } from '../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../hooks/useStore';
import styles from './DeletePersonDialog.module.css';

const DeletePersonDialog = () => {
  const { popupStore, personStore } = useStore();
  const person = personStore.personToDelete;

  const handleClose = () => {
    popupStore.setIsDeletePersonConfirmationOpen(false);
    personStore.setPersonToDelete(null);
  };

  const handleConfirm = async () => {
    if (!person?.id) {
      return;
    }

    await personStore.deletePerson(person.id);
    handleClose();
  };

  const message = person ? (
    <div className={styles.content}>
      <p className={styles.message}>Aşağıdaki kişiyi silmek istediğinizden emin misiniz?</p>
      <ul className={styles.detailList}>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>İsim</span>
          <span className={styles.detailValue}>{person.name || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Hastane</span>
          <span className={styles.detailValue}>{person.hospitalName || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>Telefon</span>
          <span className={styles.detailValue}>{person.phoneNumber || '—'}</span>
        </li>
        <li className={styles.detailItem}>
          <span className={styles.detailLabel}>E-mail</span>
          <span className={styles.detailValue}>{person.email || '—'}</span>
        </li>
      </ul>
      <p className={styles.warning}>Bu işlem geri alınamaz.</p>
    </div>
  ) : (
    'Bu kişiyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
  );

  const result = (
    <ConfirmPopup
      isOpen={popupStore.isDeletePersonConfirmationOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      intent="delete"
      title="Kişi Silme Onayı"
      description="Silme işlemi kalıcıdır"
      message={message}
      closeOnConfirm={false}
    />
  );

  return result;
};

export default observer(DeletePersonDialog);
